import React from 'react'

function Icon() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      fill='none'
      viewBox='0 0 16 16'
    >
      <path
        fill='#202020'
        fillOpacity='0.5'
        d='M8 1.333a6.667 6.667 0 110 13.333A6.667 6.667 0 018 1.333zm0 1.334a5.333 5.333 0 100 10.666A5.333 5.333 0 008 2.667zm0 2a3.333 3.333 0 11-3.187 2.35A1.666 1.666 0 008 6.334a1.667 1.667 0 00-.982-1.52c.31-.095.64-.146.982-.146z'
      ></path>
    </svg>
  )
}

export default Icon
